/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {finalizeDisputeLost} from '../api'

export const useMutationFinalizeDisputeLost = createReactQueryMutationHook('finalizeDisputeLost', finalizeDisputeLost)
